import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@vds/icons';
import { ButtonIcon } from '@vds/button-icons';
// import Favorite from '../../Common/favroite.jsx';
import './aiCalendarView.scss';
import { dynamicImageUrl, getCardFormatText, resourceTypeMapping, formatEventDate} from '../../../../utility/utils.js'; // Adjust path
import {contentClick} from "../../../../common/Analytics/GAWrapper.jsx";
const AiMobileSearchCard = ({ item }) => {
    const isRecordedEvent = Array.isArray(item?.topics) && item.topics.some(topic => topic.toLowerCase() === 'recorded event');
     const getdynamicImageUrl = dynamicImageUrl(item, item.thumbnail, 'search_results', 'schCarousel');
    const { getFormatText } = getCardFormatText('classic');
    const displayFormat = getFormatText(item);
    const aisearchJsonData = useSelector((state) => state?.Aem?.aemAiSearchData);
    const mappedResource = resourceTypeMapping(item, aisearchJsonData, window.location.origin);
    let finalLaunchUrl = mappedResource?.redirectUrl;
    let isEvent = false;
    if(item?.type.toLowerCase() == 'course'){
      if(item?.format?.toLowerCase() === 'blended' || item?.format?.toLowerCase() === 'classroom'){
        isEvent = true;
      }
    }
    const category = (item?.format || '').toLowerCase();
    const displayLabel = getAemLable(item);

    function getAemLable(item) {
        if (!item) return ''; 
        const categoryOrType = (item?.type || '').toLowerCase();
        const defaultFormat = item?.format;
        if(categoryOrType.includes('course')){
            if (defaultFormat === 'Blended') {
                return aisearchJsonData?.typeaheadCardsMapping?.events?.eyebrowText || 'Virtual event';
            } else if(defaultFormat === 'Classroom') {
                return aisearchJsonData?.typeaheadCardsMapping?.inPersonEvents?.eyebrowText || 'In-person event';
            } else if (isRecordedEvent) {
                return 'Event';
            } else {
                return aisearchJsonData?.typeaheadCardsMapping?.courses?.eyebrowText  || 'Course';
            }
        } else if (categoryOrType.includes('article')) {
            return aisearchJsonData?.typeaheadCardsMapping?.categoryquicktips?.label  || 'Quick tip';
        } else if (categoryOrType.includes('learningprogram')) {
            return aisearchJsonData?.typeaheadCardsMapping?.learningProgram?.eyebrowText  || 'Learning path';
        }
        return defaultFormat;
    };

    if (!finalLaunchUrl && item?.launchUrl) {
        try {
        const parsedRawUrl = new URL(item.launchUrl);
        finalLaunchUrl = window.location.origin + parsedRawUrl.pathname + parsedRawUrl.search + parsedRawUrl.hash;
        } catch (e) {
        finalLaunchUrl = window.location.origin + (item.launchUrl.startsWith('/') ? '' : '/') + item.launchUrl;
        }
    }
    
    return (
        <div className="ai-mobile-card pointer"
            onClick={() => {
                if (finalLaunchUrl) {
                     contentClick(
                        item?.title,
                        finalLaunchUrl,
                        item?.topics,
                        'classic_search_details_page',
                        );
                window.open(finalLaunchUrl, '_blank');
                }
            }}>
            <div
                className="ai-mobile-image"
                style={{ backgroundImage: getdynamicImageUrl  ? `url(${getdynamicImageUrl })` : undefined }}
            >
                {/* {recommended && (
        <span className="search-result-badge body-sm font-eTX-bold">Recommended</span>
    )} */}

                {/* <span className="ai-mobile-favorite">
                    <Favorite
                        courseId={id}
                        label={title}
                        format={type}
                        iconSize="small"
                        contentCategory="search_favorite"
                    />
                </span> */}
            </div>

            <div className="ai-mobile-info">
                <div className="ai-mobile-top">
                    <div className="ai-mobile-label">
                        <div className="micro font-eTX-bold">
                             {displayLabel}
                        </div>
                        {displayFormat != ''  && item?.type !== "learningProgram" && !isRecordedEvent && <span className="dot-wrap" />}
                        {displayFormat != '' && item?.type !== "learningProgram" && !isRecordedEvent && <span className='micro'>{displayFormat }</span>}
                    </div>

                </div>

                <div className="ai-mobile-title vds-title-2xs sm-mb-4X">
                    {item?.title}
                </div>

                <div className="ai-mobile-footer">
                    <div className="ai-mobile-duration">
                        {isEvent && item?.date ? (
                        <>
                            <i className='fs-4X vds-icon icon-calendar_blk color-secondary'/>
                            <div className='vds-micro font-eTX-bold color-secondary'> 
                                {formatEventDate(item.date)}
                            </div>
                        </>
                        ) : (
                        <>
                            <Icon name="timer" size="small" color="#716F6D" />
                                <span className="ml-1X micro font-eTX-bold">
                                    {item?.duration}
                                </span>
                        </>
                        )}
                    </div>
                    <ButtonIcon
                        kind="ghost"
                        size="small"
                        ariaLabel={`View ${item?.title}`}
                        renderIcon={(props) => <Icon name="right-arrow" {...props} />}
                         onClick={() => {
                             if (finalLaunchUrl) {
                                window.open(finalLaunchUrl, '_blank'); 
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default AiMobileSearchCard;